@if (settings.errorMessage) {
  <main class="sc-container sc-page">
    <h1>Square Control</h1>
    <app-state-message tone="danger" title="Square Control couldn’t start"
      message="Reload the page to try again. If the problem continues, please try again later.">
      <button type="button" appButton="secondary" (click)="reload()">Reload</button>
    </app-state-message>
  </main>
} @else {
  @if (session.storageWarning()) {
    <div class="sc-container sc-page"><app-state-message title="Browser storage" tone="warning" [message]="session.storageWarning()" /></div>
  }
  <router-outlet />
  <app-growl-host />
}
